import React,{useEffect,useContext,useState} from 'react';
import { MyContext } from '../../contexts/MyContext';
import {NavLink} from 'react-router-dom';
import {FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import logo from '../../assets/img/logo.png';
import './Menus.css';
import { AiOutlineUser, } from "react-icons/ai";
import { BiSearchAlt } from "react-icons/bi";


const Navbarmenu = (props) => {
  const {rootState} = useContext(MyContext);
  const {isAuthPro,theUserProID} = rootState;
    const [isMenu, setisMenu] = useState(false);
    const [isResponsiveclose, setResponsiveclose] = useState(false);
    const toggleClass = () => {
      setisMenu(isMenu === false ? true : false);
      setResponsiveclose(isResponsiveclose === false ? true : false);
  };
    let boxClass = ["main__menu default__menu"];
    if(isMenu) {
        boxClass.push('responsive___menu');
    }else{
        boxClass.push('');
    }
    const [isMenuSubMenu, setMenuSubMenu] = useState(false);
    const toggleSubmenu = () => {
      setMenuSubMenu(isMenuSubMenu === false ? true : false);
      setMenuSubMenutwo(false);
    };
    
    let boxClassSubMenu = ["sub__menus"];
    if(isMenuSubMenu) {
        boxClassSubMenu.push('sub__menus__Active');
    }else {
        boxClassSubMenu.push('');
    }

    const [isMenuSubMenutwo, setMenuSubMenutwo] = useState(false);
    const toggleSubmenutwo = () => {
      setMenuSubMenutwo(isMenuSubMenutwo === false ? true : false);
      setMenuSubMenu(false);
    };
    let boxClassSubMenutwo = ["sub__menus"];
    if(isMenuSubMenutwo) {
        boxClassSubMenutwo.push('sub__menustwo__Active');
    }else {
        boxClassSubMenutwo.push('');
    }
 
  return (
  <header className={props.stickysss ? "header__wrapper" : "header__wrapper" }>
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 header__wrapper__col" >
          {/* Add Logo  */}
          <div className="header__logo">
            <NavLink className={({ isActive }) => isActive ? "is-active" : ""} to="/">
              {props.pages === 'homes' ? 
                <img src={logo} alt="logo" /> 
              : 
                <img src={logo} alt="logo" /> 
              }
            </NavLink>
          </div>
          <div className="header__menus">
            <nav className="main-nav " >
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? <> 
                <span className="menubar__button" style={{ display: 'none' }} onClick={toggleClass} > <FiXCircle />   </span>
              </> : <> 
                <span className="menubar__button" style={{ display: 'none' }} onClick={toggleClass} > <FiAlignRight />   </span>
              </>}
              <ul className={boxClass.join(' ')}>
                <li  className="menu__item" ><NavLink  className={({ isActive }) => isActive ? "is-active" : ""} onClick={toggleClass} to={`/`}> Home </NavLink> </li>
				 {isAuthPro === false && theUserProID === null  ? <> 
                  <li  className="menu__item resss__show" ><NavLink onClick={toggleClass} className=' ' to={`/LoginSection`} > Post Your Book </NavLink> </li>
                  
                </>: 
                  <li  className="menu__item resss__show" ><NavLink onClick={toggleClass} className=' ' to={`/myAccount/books/planBooks/book`} > Post Your Book </NavLink></li>
                }
                <li  className="menu__item" ><NavLink  className={({ isActive }) => isActive ? "is-active" : ""} onClick={toggleClass} to={`/Books`}> Books </NavLink> </li>
                


                <li  className="menu__item" ><NavLink  className={({ isActive }) => isActive ? "is-active" : ""} onClick={toggleClass} to={`/BookCover`}> Best Book Cover </NavLink> </li>
                <li  className="menu__item" ><NavLink  className={({ isActive }) => isActive ? "is-active" : ""} onClick={toggleClass} to={`/Authors`}> Authors </NavLink> </li>

          <li  className="menu__item full__menus__arrows sub__menus__arrows" ><NavLink  onClick={toggleSubmenutwo} to="#"> More <FiChevronDown /> </NavLink> 
            <ul className={boxClassSubMenutwo.join(' ') } > 
              <li  className="menu__item" ><NavLink  className={({ isActive }) => isActive ? "is-active" : ""} onClick={toggleClass} to={`/Interviews`}> Author Interview </NavLink> </li>
                <li  className="menu__item" ><NavLink  className={({ isActive }) => isActive ? "is-active" : ""} onClick={toggleClass} to={`/Article`}> Articles </NavLink> </li>
                <li  className="menu__item" ><NavLink  className={({ isActive }) => isActive ? "is-active" : ""} onClick={toggleClass} to={`/Poem`}> Poems </NavLink> </li>
                <li  className="menu__item" ><NavLink  className={({ isActive }) => isActive ? "is-active" : ""} onClick={toggleClass} to={`/Contactus`}> Contact </NavLink> </li>
            </ul>
          </li>



               
                {isAuthPro === false && theUserProID === null  ? <> 
                  <li  className="menu__item resss__show" ><NavLink onClick={toggleClass} className=' ' to={`/LoginSection`} > Sign In </NavLink> </li>
                  
                </>: 
                  <li  className="menu__item resss__show" ><NavLink onClick={toggleClass} className=' ' to={`/myAccount/dashboard`} >  My Account </NavLink></li>
                }
                
                <li className="menu__item menu__item__search" ><NavLink onClick={toggleClass} className={({ isActive }) => isActive ? "is-active" : ""} to={`/Search`}> <BiSearchAlt /> </NavLink> </li> 
                
              </ul>
            </nav>     
          </div> 
         
         
        </div>
      </div>
	  </div>
   
  </header>
  )
}
export default Navbarmenu